import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import user1 from "../assets/img/blog-1.jpg";
import user2 from "../assets/img/blog-2.jpg";
import user3 from "../assets/img/blog-3.jpg";

const testimonials = [
  { name: "Mike Torello", role: "Executive Engineer", img: user1, text: "Adipiscing nam neque hendrerit nec pellentesque diam a. Varius quisque odio mauris lectus consequat sed. Pretium purus feugiat volutpat pellentesque. Potenti porta mauris nec vulputate" },
  { name: "Rick Wright", role: "Executive Engineer", img: user2, text: "Adipiscing nam neque hendrerit nec pellentesque diam a. Varius quisque odio mauris lectus consequat sed. Pretium purus feugiat volutpat pellentesque. Potenti porta mauris nec vulputate" },
  { name: "Devon Miles", role: "Executive Engineer", img: user3, text: "Adipiscing nam neque hendrerit nec pellentesque diam a. Varius quisque odio mauris lectus consequat sed. Pretium purus feugiat volutpat pellentesque. Potenti porta mauris nec vulputate" },
  { name: "Celia Almeida", role: "Manager", img: user1, text: "Adipiscing nam neque hendrerit nec pellentesque diam a. Varius quisque odio mauris lectus consequat sed. Pretium purus feugiat volutpat pellentesque. Potenti porta mauris nec vulputate" },
  { name: "Frank Kinney", role: "Consultant", img: user2, text: "Adipiscing nam neque hendrerit nec pellentesque diam a. Varius quisque odio mauris lectus consequat sed. Pretium purus feugiat volutpat pellentesque. Potenti porta mauris nec vulputate" },
  { name: "Sam Perry", role: "Developer", img: user3, text: "Adipiscing nam neque hendrerit nec pellentesque diam a. Varius quisque odio mauris lectus consequat sed. Pretium purus feugiat volutpat pellentesque. Potenti porta mauris nec vulputate" }
];

const Testimonials = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <section className="testimonial-wrapper" data-aos="fade-up">
        <div className="testimonial-box">

          <div className="text-center mb-4">
            <span className="section-tag">TESTIMONIALS</span>
            <h2>What Our Clients Say</h2>
            <p className="subtitle">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </p>
          </div>

          <Swiper
  modules={[Navigation, Autoplay]}
  navigation
  spaceBetween={20}
  slidesPerView={3}
  autoplay={{
    delay: 2500,              // ⭐ speed (2.5 sec)
    disableOnInteraction: false, // ⭐ user swipe केलं तरी stop होणार नाही
  }}
  breakpoints={{
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 }
  }}
>
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">
                  <div className="avatar">
                    <img src={item.img} alt={item.name} />
                  </div>
                  <p>{item.text}</p>
                  <h6>{item.name}</h6>
                  <span>{item.role}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </section>

      <style>{`

        .testimonial-box {
          background: #e9faf499;
          padding: 40px 50px;
        }

        .section-tag {
          color: #DC1F27;
          font-size: 14px;
        }

        /* ⭐ MAIN FIX */
        .swiper {
          overflow: hidden !important;
        }

        .swiper-slide {
          padding-top: 40px; /* space for avatar */
        }

        .testimonial-card {
          background: #fff;
          border-radius: 20px;
          padding: 60px 25px 25px;
          text-align: center;
          position: relative;
          min-height: 240px;
          overflow: visible; /* ⭐ important */
        }

        .avatar {
          position: absolute;
          top: -35px;
          left: 50%;
          transform: translateX(-50%);
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: #fff;
          padding: 4px;
          z-index: 10;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }
        .swiper-button-next,
        .swiper-button-prev{
       width: 30px;
          height: 30px;
          }
        .avatar img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }

        @media (max-width: 768px) {
          .testimonial-box {
            padding: 30px 15px;
          }
        }

      `}</style>
    </>
  );
};

export default Testimonials;